import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_ed8c862a/src/app/brand/[brandId]/SingleBrandPage.jsx");
